/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
if (typeof window !== 'undefined') {
    __webpack_nonce__ = window.__nonce__;
    delete window.__nonce__;
}
